import { Mutation } from "@apollo/client/react/components";
import React from "react";
import pick from "lodash/fp/pick";
import ResourcesForm, { ResourcesFormContextProvider } from "~/components/profile/ResourcesForm";
import SetGroupResources from "~/lib/mutations/SetGroupResources";
import {
  ISetGroupResourcesMutation,
  ISetGroupResourcesMutationVariables,
} from "~/lib/mutations/__generated__/SetGroupResources.generated";
import { Margin } from "~/components/spacings";
import { IFlatResource } from "~/types/types";
import { IGroupProps } from "~/components/group/IGroupProps";

export default function GroupResources({ group }: IGroupProps) {
  return (
    <Margin mt={24}>
      <ResourcesFormContextProvider>
        <Mutation<ISetGroupResourcesMutation, ISetGroupResourcesMutationVariables> mutation={SetGroupResources}>
          {(setGroupResources) => (
            <ResourcesForm
              resources={group.resources as IFlatResource[]}
              dataIntercomTarget="Group Resources Box"
              viewOnly={!group.viewerCanHeadContent || !group.viewerIsMember}
              onAdd={(resource) => {
                setGroupResources({
                  variables: {
                    id: group._id,
                    resources: [resource, ...(group.resources as IFlatResource[])].map(
                      pick(["type", "title", "url", "filename", "body", "addedAt"]) as any,
                    ),
                  },
                });
              }}
              onRemove={(resource) =>
                setGroupResources({
                  variables: {
                    id: group._id,
                    resources: (group.resources as IFlatResource[])
                      .filter((r) => r !== resource)
                      .map(pick(["type", "title", "url", "filename", "body", "addedAt"])) as any,
                  },
                })
              }
            />
          )}
        </Mutation>
      </ResourcesFormContextProvider>
    </Margin>
  );
}
